var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
// shared-library
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/redeemDetail.scss";
import { addCommasWithConditionalDecimal } from "@domains/utils/numberMethods";
import { getDateInFormat } from "@domains/utils/reportDates";
var RedeemDetails = function (_a) {
    var item = _a.item;
    //
    var data = item === null || item === void 0 ? void 0 : item.data;
    var _b = __read(useState(false), 2), showMore = _b[0], setShowMore = _b[1];
    return (React.createElement("div", { className: "top-container first-top-container" },
        React.createElement("div", { className: "top-list" },
            React.createElement("div", { className: "top-left" },
                React.createElement("p", { className: "top-title DMSans_13_400" }, "Available To Redeem"),
                React.createElement("p", { className: "top-subtitle RobotoM_15_400 number-large" },
                    "\u20B9",
                    addCommasWithConditionalDecimal((data === null || data === void 0 ? void 0 : data.amount) || "-")),
                React.createElement("p", { className: "top-title Roboto_10_400" },
                    "(As Of ",
                    getDateInFormat(data === null || data === void 0 ? void 0 : data.holdingdate, "DD MMM YYYY, hA"),
                    ")")),
            React.createElement("div", { className: "separator" }),
            React.createElement("div", { className: "top-right" },
                React.createElement("p", { className: "top-title DMSans_13_400" }, "Units"),
                React.createElement("p", { className: "top-subtitle RobotoM_15_400 number-large" }, data === null || data === void 0 ? void 0 : data.units))),
        showMore && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "top-list-container" },
                React.createElement("p", { className: "top-title DMSans_13_400" }, "Redemption Time"),
                React.createElement("p", { className: "top-subtitle Roboto_13_400" }, (data === null || data === void 0 ? void 0 : data.redemptiontime) || "-")),
            React.createElement("div", { className: "top-list-container" },
                React.createElement("p", { className: "top-title DMSans_13_400" }, "Initial Purchase Date"),
                React.createElement("p", { className: "top-subtitle Roboto_13_400" }, (data === null || data === void 0 ? void 0 : data.initialpurchasedate)
                    ? getDateInFormat(data === null || data === void 0 ? void 0 : data.initialpurchasedate, "DD MMM YYYY")
                    : "-")),
            React.createElement("div", { className: "top-list-container" },
                React.createElement("p", { className: "top-title DMSans_13_400" }, "RM Name/Code"),
                React.createElement("p", { className: "top-subtitle Roboto_13_400" },
                    (data === null || data === void 0 ? void 0 : data.rmName) || "-",
                    "/",
                    (data === null || data === void 0 ? void 0 : data.rmCode) || "-")))),
        React.createElement("div", { className: "d-flex justify-content-center align-items-center gap-1 ".concat(showMore && "mt-2 gap-2") },
            React.createElement(EdButton, { value: "".concat(showMore ? "Less Details" : "More Details"), btnTyp: "link", className: "small-link-btn  DMSans_13_400 text-transform-none", onClick: function () { return setShowMore(!showMore); } }),
            React.createElement("i", { className: "d-flex justify-content-center align-items-center size-16 ".concat(showMore
                    ? "edel-icon-arrow-up text-han-blue"
                    : "edel-icon-arrow-down text-han-blue") }))));
};
export default RedeemDetails;
